export interface IFishboneType
{
    fbId: number,
    description: string
    archived: boolean,
    sortOrder: number
}

export interface IFishboneSubType
{
    fbId: number,
    fbSubId: number,
    label: string,
    description: string,
    archived: boolean,
    sortOrder: number
}

export interface IFishboneOrder
{
    orderId: number,
    fbId: number,
    orderLocationId: number,
    orderCode: string,
    archived: boolean,
    sortOrder: number
}

export interface IFishboneOrderLocation
{
    locationId: number,
    name: string,
    displayName: string
}

export interface IFishboneOrderResult
{
    orderId: number,
    fbSubId: number,
    fbResultCodeType: string,
    fbResultCode: string
}

export interface IFishboneOrderResultParsed
{
    fbOrderLabel?: string,
    fbOrderLocationId?: number,
    fbItemLabel?: string,
    fbResultCodeType: string,
    fbResultCode: string
}


export interface IFishboneCreateType
{
    description: string,
    archived: boolean,
    sortOrder: number
}

export interface IFishboneCreateSubType
{
    fbId?: number,
    label: string,
    description: string,
    archived: boolean,
    sortOrder: number
}

export interface IFishboneCreateOrder
{
    fbId?: number,
    orderLocationId: number,
    orderCode: string,
    archived: boolean,
    sortOrder: number
}

export interface IFishboneCreatePayload
{
    fishbone?: IFishboneCreateType,
    fishboneItems?: IFishboneCreateSubType[],
    fishboneOrders?: IFishboneCreateOrder[],
    fishboneResults?: IFishboneOrderResult[]
}

export enum FishboneResultCodeType {
    LOINC = "L",
    Result = "R",
    GlobalEntity = "G"
}

export interface IFishboneResultCodeType
{
    value: string,
    displayValue: string
}

export interface IWireframeCreatePayload
{
    fbId: number,
    imageName: string,
    wireframeName: string
}

export interface IWireframe
{
    wireframeId: number,
    fbId: number,
    imageName: string,
    wireframeName: string,
    disabled: boolean
}

export interface IWireframeConfiguration
{
    wireframeId: number,
    fbId: number,
    fbSubId: number,
    fbSubType: WireframeSubType,
    fbLeft: number,
    fbTop: number,
    fbHeight: number,
    fbWidth: number
}

export enum WireframeSubType {
    Result = "R",
    Label = "L"
}

export const ResultCodeTypes: IFishboneResultCodeType[] =
[
    {
        value: FishboneResultCodeType.LOINC,
        displayValue: "LOINC"
    },
    {
        value: FishboneResultCodeType.Result,
        displayValue: "Result"
    },
    {
        value: FishboneResultCodeType.GlobalEntity,
        displayValue: "Global Entity"
    }
];